import script from "./Logo.vue?vue&type=script&setup=true&lang=ts"
export * from "./Logo.vue?vue&type=script&setup=true&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=1ee90428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee90428"]])

export default __exports__